<template>
  <div class="mainChartBox" ref="mainChartContainer"></div>
</template>

<script>
const echarts = require("echarts");

export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    // 颜色渐变的方向，横向 row ，纵向 col
    linearDir: {
      type: String,
      default: "col",
    },

    // 是否执行下resize
    isResize: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mainColor: [
        ["#2478FF", "rgba(36,120,255,0)"],
        ["#3ED1E8", "rgba(65,209,230,0)"],
        ["#9C8CFF", "rgba(156,140,255,0)"],
      ],
      // 初始默认项
      defaultOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params) => {
            const { name, value } = params;
            let str = `<div class="echart_cus_title">${params[0].name}</div>`;
            for (let i = 0; i < params.length; i++) {
              const dt = params[i];
              str += `<div class="echart_cus_data"><div class="echart_cus_data_name">${dt.seriesName}</div><div class="echart_cus_data_value">${dt.value}</div></div>`;
            }

            return str;
          },
        },
        grid: {
          left: "20px",
          right: "20px",
          top: "20px",
          bottom: "20px",
          containLabel: true,
        },
        color: [],
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "value",
        },
      },
    };
  },
  watch: {
    options: {
      immediate: true,
      deep: false,
      handler(opt) {
        if (opt && typeof opt === "object") {
          this.initChart();

          // 某些项需要单独处理
          let option = { ...this.defaultOption }; // 浅拷贝
          for (let key in opt) {
            // 优先使用传进的值，只做部分调整
            switch (key) {
              case "series":
                option.series = [];
                opt[key].forEach((item) => {
                  if (!item.barWidth) item.barWidth = 18;
                  if (!item.itemStyle)
                    item.itemStyle = {
                      borderRadius:
                        this.linearDir === "col"
                          ? [100, 100, 0, 0]
                          : [0, 100, 100, 0],
                    };
                  option.series.push(item);
                });
                break;
              case "xAxis":
              case "yAxis":
                if (!opt[key].axisLine) {
                  opt[key].axisLine = {
                    lineStyle: {
                      color: "#CFD0DB",
                      opacity: 0.5,
                    },
                  };
                }
                if (!opt[key].splitLine) {
                  opt[key].splitLine = {
                    show: false,
                    lineStyle: {
                      color: "#CFD0DB",
                      opacity: 0.5,
                    },
                  };
                }

                if (!opt[key].axisLabel) {
                  opt[key].axisLabel = {
                    show: true,
                    color: "#333333",
                  };
                }

                if (!opt[key].axisTick) opt[key].axisTick = { show: false };

                option[key] = opt[key];
                break;
              default:
                option[key] = opt[key]; // 不需要特殊处理直接替换
                break;
            }
          }

          // option = Object.assign(this.defaultOption, option);
          this.$nextTick(() => {
            if (this.myChart) {
              // this.myChart.showLoading();
              this.myChart.setOption(option);
            }
          });
        }
      },
    },

    isResize(){
      this.resize();
    }
  },
  mounted() {
    this.setColors();
    this.initChart();

    window.addEventListener("resize", this.resize);
  },
  methods: {
    // 设置柱形图的颜色
    setColors() {
      const coords =
        this.linearDir === "col"
          ? {
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
            }
          : {
              x: 1,
              y: 1,
              x2: 0,
              y2: 0,
            };
      for (let i = 0; i < this.mainColor.length; i++) {
        this.defaultOption.color.push({
          type: "linear",
          ...coords,
          colorStops: [
            {
              offset: 0,
              color: this.mainColor[i][0], // 0% 处的颜色
            },
            {
              offset: 1,
              color: this.mainColor[i][1], // 100% 处的颜色
            },
          ],
          // global: true, // 缺省为 false
        });
      }
    },
    initChart() {
      if (!this.myChart && this.$refs.mainChartContainer) {
        this.myChart = echarts.init(this.$refs.mainChartContainer);
      }
    },
    // 发生变动图表对应变动
    resize() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.myChart && this.myChart.resize();
      }, 100);
    },
  },
  destoryed() {
    window.removeEventListener("resize", this.resize);
  },
};
</script>

<style lang="scss" scoped>
.mainChartBox {
  width: 100%;
  height: 100%;

  /deep/ .echart_cus_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    line-height: 17px;
  }
  /deep/ .echart_cus_data {
    width: 116px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #6d6f80;
    line-height: 17px;
    margin-top: 6px;
  }

  $chart-colors: #3c85ff, #53d6ea, #a798ff;

  // 循环生成颜色样式
  @for $i from 1 through length($chart-colors) {
    /deep/ .echart_cus_data:nth-of-type(#{$i + 1}) {
      position: relative;
      padding-left: 12px;
      &::before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 10px;
        background: nth($chart-colors, $i);
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -3px;
      }
      .echart_cus_data_value {
        color: nth($chart-colors, $i);
      }
    }
  }
  // /deep/ .echart_cus_data:nth-of-type(2) .echart_cus_data_value {
  //   color: red;
  // }
}
</style>
